import useUserStore from "../states/user";

export function fetchWithOrganization(url, options = {}) {
    const organizationId = useUserStore.getState().session?.organization_id;
    if (!organizationId) {
        throw new Error("No organization found for this request. Please sign in again.");
    }

    const method = (options.method || "GET").toUpperCase();
    if (method === "GET" || method === "HEAD") {
        const requestUrl = new URL(url);
        requestUrl.searchParams.set("organization_id", organizationId);
        return fetch(requestUrl.toString(), options);
    }

    return fetch(url, {
        ...options,
        headers: { ...options.headers, "Content-Type": "application/json" },
        body: JSON.stringify({
            ...(options.body ? JSON.parse(options.body) : {}),
            organization_id: organizationId,
        }),
    });
}
